module.exports = __webpack_public_path__ + "img/sm4_livinguard_m.c021d34a.png";